// PartsStatusSelect — gated by `partsStatuses`. When OFF, renders read-only "Needed".
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { useFeatureFlag } from '@/hooks/useFeatureFlags';
import type { PartsLineStatus } from '@/hooks/parts/usePartsLines';

const STATUS_OPTIONS: { value: PartsLineStatus; label: string }[] = [
  { value: 'needed', label: 'Needed' },
  { value: 'researching', label: 'Researching' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'awaiting_approval', label: 'Awaiting Approval' },
  { value: 'ordered', label: 'Ordered' },
  { value: 'backordered', label: 'Backordered' },
  { value: 'received', label: 'Received' },
  { value: 'installed', label: 'Installed' },
  { value: 'returned', label: 'Returned' },
  { value: 'canceled', label: 'Canceled' },
];

export function statusLabel(s: PartsLineStatus): string {
  return STATUS_OPTIONS.find((o) => o.value === s)?.label ?? s;
}

export function PartsStatusSelect({
  value,
  onChange,
  disabled,
}: {
  value: PartsLineStatus;
  onChange: (next: PartsLineStatus) => void;
  disabled?: boolean;
}) {
  const enabled = useFeatureFlag('partsStatuses');

  if (!enabled) {
    return (
      <Badge variant="secondary" className="font-normal">
        {statusLabel(value)}
      </Badge>
    );
  }

  return (
    <Select value={value} onValueChange={(v) => onChange(v as PartsLineStatus)} disabled={disabled}>
      <SelectTrigger className="h-8 w-[180px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
